/**
 * API Keys API
 * API გასაღებების API
 */

import { get, post, del } from '@aiia/portal-core';

export interface ApiKey {
  id: string;
  keyPrefix: string;
  keyValue?: string;
  name: string;
  allowedDomains: string[];
  allowedIps: string[];
  status: string;
  lastUsedAt?: string;
  createdAt: string;
}

export interface CreateApiKeyRequest {
  name: string;
  allowedDomains?: string[];
  allowedIps?: string[];
}

export interface CreateApiKeyResponse extends ApiKey {
  rawKey: string; // Only returned on creation
}

// Get all API keys for current user
export const getApiKeys = () =>
  get<ApiKey[]>('/api-keys');

// Get API key by ID
export const getApiKey = (keyId: string) =>
  get<ApiKey>(`/api-keys/${keyId}`);

// Create new API key
export const createApiKey = (data: CreateApiKeyRequest) =>
  post<CreateApiKeyResponse>('/api-keys', data);

// Revoke API key
export const revokeApiKey = (keyId: string) =>
  post<ApiKey>(`/api-keys/${keyId}/revoke`, {});

// Delete API key
export const deleteApiKey = (keyId: string) =>
  del<void>(`/api-keys/${keyId}`);
